import { unref } from 'vue';
import type { MaybeRef } from '@vueuse/core';

export default <T>(
    labelKey: MaybeRef<string> = null,
    itemLabelFn: (param: T) => string = null,
  ) =>
  (item: T): string => {
    if (item == null) return '';

    if (unref(itemLabelFn) != null) {
      return unref(itemLabelFn).call(null, item);
    }

    if (unref(labelKey) != null && typeof item === 'object') {
      return item[unref(labelKey)];
    }

    return item.toString();
  };
